// removed by extract-text-webpack-plugin
module.exports = {"header":"_1k2a_4-9h7DRzORCZhlAuu","accordion":"_2L_1R4YSSbQw2bv4coYXsT","title":"_1QakH6Brf05F_TXCVNbHx4","icon":"_2bxOsdBh6rg5aOBrh7_lTP"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/molecules/AccordionSection/style.module.css
// module id = 507
// module chunks = 37